import { render, staticRenderFns } from "./selMajor.vue?vue&type=template&id=88668f26&scoped=true&"
import script from "./selMajor.vue?vue&type=script&lang=js&"
export * from "./selMajor.vue?vue&type=script&lang=js&"
import style0 from "./selMajor.vue?vue&type=style&index=0&id=88668f26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88668f26",
  null
  
)

export default component.exports